import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { LetterShowClick, ReminderToCollegeLetterValidate } from '../../../config/Validate';
import { defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { getAllDetailsDirect, getSpecificDetailsById, postAllData } from '../../../service/ProductService';
import { DOWNLOADREMINDERLETTER, DOWNLOADVERIFICATIONLETTER, LETTERMASTERCOLLEGELIST, REMINDERLETTER, STOREREMINDER } from '../../../config/ApiConstant';
import { ReminderToCollegeListColumns } from '../../../appconfig/DatatableSetting';
import { commonMultipleTemplate, commonNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';

import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { LettersTab } from '../LettersTab';
import { ReminderTab } from './ReminderLettersTab';
import Loader from '../../../components/Loadeer/Loader';

export const ReminderToCollege = () => {
    document.title = 'College Reminder Letter | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [regNo, setRegNo] = useState<any>(null);
    const [collegeData, setCollegeData] = useState<any>({});
    const [addLoader, setAddLoader] = useState<boolean>(false);
    const [collegeList, setCollegeList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [buttonVisible, setButtonVisible] = useState<boolean>(true);
    const [collegesOptions, setCollegesOptions] = useState<any>([]);
    const [selectedCollege, setSelectedCollege] = useState<any>(null);
    const [collegeAddress, setcollegeAddress] = useState<any>([]);

    // useEffect
    useEffect(() => {
        reminderToCollegeLetter();
        getAllColleges();
    }, []);

    // Get University
    const getAllColleges = async () => {
        try {
            const response = await getAllDetailsDirect(LETTERMASTERCOLLEGELIST + '?type=all');

            if (response) {
                const DataList: any = response?.data;
                if (DataList.length === 0) {
                    setCollegesOptions([]);
                } else {
                    setcollegeAddress(DataList);

                    let collegeData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const collegeObj: any = {};
                        collegeObj['name'] = DataList[i].orgnameeng;
                        collegeObj['code'] = DataList[i].orgcode;
                        collegeData.push(collegeObj);
                    }
                    setCollegesOptions(collegeData);
                }
            } else {
                setCollegesOptions([]);
            }
        } catch (error: any) {
            setCollegesOptions([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // Clear all
    const clearAll = () => {
        setRegNo(null);
        reminderToCollegeLetter();
        setCollegeData({});
        setSelectedCollege(null);
        setErrors({});
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val = (e.target && e.target.value) || e.value || '';

        setCollegeData({ ...collegeData, [name]: val });
    };

    // getUniversitLetterList
    const reminderToCollegeLetter = async () => {
        if (!window.cn(regNo)) {
            try {
                const response = await getAllDetailsDirect(REMINDERLETTER + '?ReminderBy=College' + '&FileNo=' + regNo);
                const { List } = response;
                if (!window.cn(response) && Object.keys(response?.Details).length !== 0) {
                    const { StudF, StudM, StudL } = response?.Details;
                    let FromNm = (!window.cn(StudL) ? StudL : '') + ' ' + (!window.cn(StudF) ? StudF : '') + ' ' + (!window.cn(StudM) ? StudM : '');
                    setCollegeData({
                        Name: FromNm
                    });
                    setCollegeList(List);
                    setShowLoading(false);
                    setButtonVisible(false);
                } else {
                    setButtonVisible(true);
                    setShowLoading(false);
                    setCollegeData({ ...collegeData });
                }
            } catch (error: any) {
                if (error.response) {
                    //Spinner False and Set Toast
                    setShowLoading(false);
                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                }
            }
        } else {
            try {
                setPageLoad(false);
                const response = await getAllDetailsDirect(REMINDERLETTER + '?ReminderBy=College');

                if (response) {
                    const { List } = response;
                    setCollegeList(List);
                    setPageLoad(true);
                }
            } catch (error: any) {
                if (error.response) {
                    //Spinner False and Set Toast
                    setPageLoad(true);

                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                }
            }
        }
    };

    //\ onShowClick get User Deatsils
    const getUserDetails = async () => {
        try {
            const { errors, isError } = LetterShowClick(regNo);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setShowLoading(true);
                // setPageLoad(false);

                reminderToCollegeLetter();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setShowLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };
    //onchange event
    const onCollegeSelect = (e: any) => {
        setSelectedCollege(e);
        getcollegeAddress(e);
    };

    //getUniversirtAddress
    const getcollegeAddress = (name: any) => {
        collegeAddress.map((item: any) => {
            if (item?.orgcode === name?.code) {
                setCollegeData({ ...collegeData, ToAddress: item?.Address ? item.Address : '' });
            }
        });
    };

    // Add inward data
    const addcollegeData = async () => {
        try {
            const { errors, isError } = ReminderToCollegeLetterValidate(collegeData, selectedCollege, regNo);
            setErrors(errors);
            //Check Error if no errors then call API
            if (!isError) {
                setAddLoader(true);

                let requestData = { ...collegeData };
                requestData['FileNo'] = Number(regNo);
                requestData['ReminderId'] = selectedCollege?.code;
                requestData['ReminderName'] = selectedCollege?.name;
                requestData['ReminderBy'] = 'College';

                const response = await postAllData(STOREREMINDER, requestData);
                if (response) {
                    setAddLoader(false);
                    toast.current?.show({ severity: 'success', summary: 'Message', detail: response?.data });
                    setCollegeData({});
                    clearAll();
                    reminderToCollegeLetter();
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setAddLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Template for actions
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button icon="pi pi-download" onClick={() => downloadReminderToCollegeLetter(rowData?.SrNo)} tooltip="Download" tooltipOptions={{ position: 'top' }} />
                </div>
            </>
        );
    };

    // Download bank entry
    const downloadReminderToCollegeLetter = async (id: any) => {
        try {
            setLoading(true);

            const response = await getSpecificDetailsById(DOWNLOADREMINDERLETTER, id);

            //Check response and download
            if (response) {
                //PDF Download
                const { file_url } = response;
                setLoading(false);

                //PDF Download
                const fileName = `reminder-college-letter-${new Date().getTime()}.pdf`;
                const link = document.createElement('a');
                link.href = file_url;
                link.target = '_blank';
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <LettersTab mainTabLabel="Reminder Letters" />
            <ReminderTab initialTabLabel="Reminder To College" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="p-fluid formgrid grid align-items-center">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="regNo">
                                    File No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(regNo) ? regNo : ''} name="regNo" keyfilter="num" autoComplete="off" placeholder="Enter File No." onChange={(e) => setRegNo(e.target.value)} className={errors['regNo'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['regNo']}</small>
                            </div>
                            <div className="field col-12 md:col-1 mt-4">
                                <Button label="Search" className="p-button-primary" onClick={() => getUserDetails()} loading={showLoading} />
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="Name">
                                    Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(collegeData?.Name) ? collegeData?.Name : ''} name="Name" disabled={true} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="collegeName">
                                    College Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Dropdown
                                    value={selectedCollege}
                                    name="collegeName"
                                    options={collegesOptions}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select College"
                                    onChange={(e) => onCollegeSelect(e.value)}
                                    className={errors['collegeName'] && 'p-invalid'}
                                />
                                <small className="p-invalid-txt">{errors['collegeName']}</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="Reference">
                                    Reference <span style={{ color: 'red' }}>*</span>
                                </label>

                                <InputText value={!window.cn(collegeData?.Reference) ? collegeData?.Reference : ''} name="Reference" onChange={(e) => onInputChange(e, 'Reference')} className={errors['Reference'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['Reference']}</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="ToAddress">
                                    Address <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputTextarea value={!window.cn(collegeData?.ToAddress) ? collegeData?.ToAddress : ''} name="ToAddress" disabled={true} rows={4} />
                                <small className="p-invalid-txt">{errors['ToAddress']}</small>
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-12">
                                <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                                    <Button label="Clear" icon="pi pi-times" className="p-button-secondary mr-2" onClick={() => clearAll()} />
                                    <Button label="Save" icon="pi pi-check" onClick={() => addcollegeData()} loading={addLoader} disabled={buttonVisible} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={collegeList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={collegeList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {ReminderToCollegeListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'created_at') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'UniBordCol') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commonNameTemplate} />;
                                        } else if (col.field === 'ToAddress') {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        } else if (col.field === 'FileNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} style={{ minWidth: '8rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {ReminderToCollegeListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {loading === true ? <Loader /> : ''}

        </>
    );
};
